import * as React from "react";
const SkipSquareIcon = (props) => (
  <svg
    width={50}
    height={50}
    viewBox="0 0 50 50"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M42 4C44.2091 4 46 5.79086 46 8V42C46 44.2091 44.2091 46 42 46H8C5.79086 46 4 44.2091 4 42V8C4 5.79086 5.79086 4 8 4H42ZM30 16V34H34V16H30ZM16 33L29 25L16 17V33Z"
      fill="#EBC351"
    />
  </svg>
);
export default SkipSquareIcon;